export const List = [
    {
       id: 1,
    Title: 'Crash Landing on You',
    Year: '2019–2020',
    Rate: '8.8/10',
    Des: 'A paragliding mishap drops a South Korean heiress in North Korea - and into the life of an army officer, who decides he will help her hide',
    Poster: 'https://m.media-amazon.com/images/M/MV5BMzRiZWUyN2YtNDI4YS00NTg2LTg0OTgtMGI2ZjU4ODQ4Yjk3XkEyXkFqcGdeQXVyNTI5NjIyMw@@._V1_SX300.jpg'
    },
    {
       id:2,
        Title: 'Backstreet Rookie',
        Year: '2020–',
        Rate: '7.5/10',
        Des: 'Backstreet Rookie is a 2020 South Korean television series starring Ji Chang-wook and Kim Yoo-jung. It is based on the 2016–2017 webtoon Convenience Store',
        Poster: 'https://m.media-amazon.com/images/M/MV5BZWNmNWNlZWMtYmRjMy00YzRiLWI3NDYtYzNlNDUzZDA0YjAwXkEyXkFqcGdeQXVyMTE2MTc3MzU1._V1_SX300.jpg'
        },
        {
           id:3,
            Title:' Its Okay to Not Be Okay',
            Year: '2020–',
            Rate: '-',
            Des: 'A road to emotional healing opens up for an antisocial childrens book author and an employee in a psychiatric hospital.',
            Poster: 'https://m.media-amazon.com/images/M/MV5BNTEyODhjZmItYTM2Yy00ODFjLTk4YWUtNjEzMmY2ZGFlYjEzXkEyXkFqcGdeQXVyNDY5MjMyNTg@._V1_SX300.jpg'
            },
            {
               id:4,
                Title: 'Doctor Stranger',
                Year: '2014–',
                Rate: '7.4/10',
                Des: 'A young doctor flees North Korea for life in the south, where he finds a woman who looks exactly like the woman he lost track of during his escape.',
                Poster: 'https://m.media-amazon.com/images/M/MV5BMTc5YTAwMWQtZDBlNS00OTAzLWJlYzYtODVmMTRmYjVhMWE4XkEyXkFqcGdeQXVyMzE4MDkyNTA@._V1_SX300.jpg'
                },
                {
                   id:5,
                    Title: 'Doctor Prisnor',
                    Year: '2019',
                    Rate: '7.7/10',
                    Des: 'An ace doctor in a university hospital is wrongfully accused of a medical malpractice incident and gets ousted from the hospital. He then applies to work at a prison.',
                    Poster: 'https://m.media-amazon.com/images/M/MV5BZjk3M2E1Y2ItOWVjNC00ODgwLWJjMTctNDUzYmRjZTNmMzg2XkEyXkFqcGdeQXVyMTMxODk2OTU@._V1_.jpg'
                    },
                    {
                       id:6,
                        Title: 'Legend of the Blue Sea',
                        Year: '2016–2017',
                        Rate: '8.1/10',
                        Des: 'A magistrates plan to release mermaids into the ocean backfires when they are caught by fishermen.                                                               ' ,
                        Poster:'https://m.media-amazon.com/images/M/MV5BZjAwZTU3NzUtZDExNi00NDk4LTkzYWItNGEzNDUwOWU0M2Q5L2ltYWdlL2ltYWdlXkEyXkFqcGdeQXVyMzE4MDkyNTA@._V1_SX300.jpg'
                        },
                        {
                           id:7,
                            Title:'Descendants of the Sun',
                            Year:'2016',
                            Rate:'8.4/10',
                            Des:' A love story between Captain Yoo Shi Jin, Korean Special Forces, and Doctor Kang Mo Yeon, surgeon at Haesung Hospital. Together they face danger in a war-torn country.',
                            Poster:'https://m.media-amazon.com/images/M/MV5BM2ExNGE4ZjItMmY5My00ZDU5LWJiMzMtOTFjMDRmNWVlMzZiXkEyXkFqcGdeQXVyMzE4MDkyNTA@._V1_SX300.jpg'
                            },
                            {
                               id:8,
                                Title:'Suspicious Partner',
                                Year:'2017',
                                Rate:'7.9/10',
                                Des:'Life is upended for a prosecutor after meeting his new intern who becomes a prime murder suspect soon after joining his office.',
                                Poster:'https://m.media-amazon.com/images/M/MV5BNTdjOTUwYmYtNWQ0MC00ZWRkLWI0NmYtMzY5NThhYWVhNGM4XkEyXkFqcGdeQXVyNzk0NTA5NQ@@._V1_SX300.jpg'
                                },
                                {
                                   id:9,
                                    Title:'The K2',
                                    Year:'2016',
                                    Rate:'7.8/10',
                                    Des:'While in Iraq, a soldier gets framed for the murder of his lover and becomes a fugitive.',
                                    Poster:'https://m.media-amazon.com/images/M/MV5BMGI1MDIzNTItMzg1ZS00MmFkLWFlZDEtYmVmZWVkMDZkM2U3XkEyXkFqcGdeQXVyMTMxODk2OTU@._V1_SX300.jpg'
                                    },
                                    {
                                       id:10,
                                        Title:'Healer',
                                        Year:'2014–2015',
                                        Rate:'8.5/10',
                                        Des:'A fighter posing as a night courier agrees to protect a tabloid journalist whose investigation into a long-buried tragedy makes her a target for assassination.',
                                        Poster:'https://m.media-amazon.com/images/M/MV5BZDJhMDI5MWYtOTUxMS00ZDk1LWExMDItNTZmNWJiZjhkMzdhXkEyXkFqcGdeQXVyMzE4MDkyNTA@._V1_SX300.jpg'
                                        }

    ]